<template>
  <div class="header">
    <div class="pc-header-v3 pc-header-v3-1">
        <div class="header-v3-mainbody header-v3-topbar J-header-v3-bar">
          <div class="header-v3-content">
            <div class="header-v3-language-con">
              <div
                class="header-v3-content-pc"
                data-domain="https://www.cgtn.com"
              ></div>
              <div
                class="header-v3-content-ipad"
                data-domain="https://www.cgtn.com"
              ></div>
              <div class="header-v3-lang-content">
                <a href="#language" class="header-v3-lang-tit">Language</a>
                <div class="header-v3-lang-list">
                  <a class="isEnglishActive" href="https://www.cgtn.com/tv"
                    >English</a
                  >
                  <a href="https://espanol.cgtn.com">Español</a>
                  <a href="https://francais.cgtn.com">Français</a>
                  <a href="https://arabic.cgtn.com">العربية</a>
                  <a href="https://russian.cgtn.com">Русский</a>
                </div>
              </div>
            </div>
            <a
              href="https://www.cgtn.com"
              class="bar-logo header-v3-logo"
              target="_self"
              data-category="Home"
              data-list=""
              data-action="Logo_Click"
              data-label=""
              data-position=""
              data-index=""
              data-news-id=""
              data-time=""
            ></a>
            <div class="header-v3-sharecon">
              <div class="header-v3-shareicon">
                <a
                  href="javascript:;"
                  class="shareicon shrink more J-header-v3-more"
                ></a>
                <div class="header-v3-follow J-icon-follow">
                  <ul class="header-v3-follow-common">
                    <li class="fl">
                      <a
                        href="https://www.facebook.com/ChinaGlobalTVNetwork"
                        class="icon fb cg-com-sprite"
                        target="_blank"
                        data-category="Home"
                        data-list=""
                        data-action="Socialmedia_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      ></a>
                    </li>
                    <li class="fl">
                      <a
                        href="https://twitter.com/CGTNOfficial"
                        class="icon twitter cg-com-sprite"
                        target="_blank"
                        data-category="Home"
                        data-list=""
                        data-action="Socialmedia_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                      </a>
                    </li>
                    <li class="fl">
                      <a
                        href="https://www.youtube.com/CGTN"
                        class="icon youtube cg-com-sprite"
                        target="_blank"
                        data-category="Home"
                        data-list=""
                        data-action="Socialmedia_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                      </a>
                    </li>
                    <li class="fl">
                      <a
                        href="https://www.instagram.com/cgtn"
                        class="icon ins cg-com-sprite"
                        target="_blank"
                        data-category="Home"
                        data-list=""
                        data-action="Socialmedia_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                      </a>
                    </li>
                    <li class="fl">
                      <a
                        href="https://v.douyin.com/2VMKvpC"
                        class="icon douyin cg-com-sprite"
                        target="_blank"
                        data-category="Home"
                        data-list=""
                        data-action="Socialmedia_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                      </a>
                    </li>
                    <li class="fl">
                      <a
                        href="http://weibo.com/cctvnewsbeijing"
                        class="icon weibo cg-com-sprite"
                        target="_blank"
                        data-category="Home"
                        data-list=""
                        data-action="Socialmedia_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                      </a>
                    </li>
                    <li class="fl">
                      <a
                        href="javascript:;"
                        class="icon wechat cg-com-sprite"
                        target="_self"
                        data-category="Home"
                        data-list=""
                        data-action="Socialmedia_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                      </a>
                    </li>
                    <li class="fl">
                      <a
                        href="https://www.pinterest.com/CGTNOfficial"
                        class="icon pinterest cg-com-sprite"
                        target="_blank"
                        data-category="Home"
                        data-list=""
                        data-action="Socialmedia_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                      </a>
                    </li>
                    <!-- <li class="fl">
                                        <a href="http://www.miaopai.com/u/paike_1300pl6n77" class="icon miaopai cg-com-sprite" target="_blank" data-category="Home" data-list="" data-action="Socialmedia_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                        </a>
                                    </li> -->
                    <li class="fl">
                      <a
                        href="https://www.toutiao.com/c/user/82615367134/#mid=1588042509127693"
                        class="icon toutiao cg-com-sprite"
                        target="_blank"
                        data-category="Home"
                        data-list=""
                        data-action="Socialmedia_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                      </a>
                    </li>
                    <li class="fl">
                      <a
                        href="https://www.quora.com/profile/CGTN-Social-Team"
                        class="icon quora cg-com-sprite"
                        target="_blank"
                        data-category="Home"
                        data-list=""
                        data-action="Socialmedia_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                      </a>
                    </li>
                    <li class="fl">
                      <a
                        href="https://www.linkedin.com/company/cgtn"
                        class="icon linkedin cg-com-sprite"
                        target="_blank"
                        data-category="Home"
                        data-list=""
                        data-action="Socialmedia_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="header-v3-wechat J-header-v3-wechat"></div>
              <div
                class="header-v3-login-con J_login_warp"
                data-domain="https://www.cgtn.com"
              >
                <a
                  href="https://www.cgtn.com/subscribe/rss.html"
                  class="title-item title-item-rss"
                  ><i class="icon-default"></i>RSS</a
                >
                <a
                  href="https://www.cgtn.com/subscribe/newsletter.html"
                  class="title-item title-item-sub"
                  ><i class="icon-default"></i>Newsletters</a
                >
                <div class="title-item-line"></div>
                <div class="title-item title-item-message J_msg">
                  <i class="icon-default"></i>
                </div>
                <div class="title-item title-item-sign J_login">
                  <i class="icon-default"></i>
                  <span class="signin_value">SIGN IN</span>
                  <span class="signin_value_acitve">USER</span>
                  <div class="title-login-content J_login_content">
                    <a class="J_accout">Your account</a>
                    <a class="J_signout">Sign out</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="header-v3-nav-warp J-header-v3-nav-warp">
          <div class="header-v3-mainbody">
            <div class="header-v3-main-nav header-v3-main-bj">
              <ul class="header-v3-navlists">
                <li
                  data-click-name="Home"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Home
                  </a>
                </li>
                <li
                  data-click-name="China"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/china"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    China
                  </a>
                </li>
                <li
                  data-click-name="World"
                  data-page="Home"
                  data-list="children_list"
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/world"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    World
                    <i class="icon-top cg-com-sprite"></i>
                  </a>
                  <div class="header-nav-anotherlist" style="display: none">
                    <div class="header-v3-mainbody">
                      <ul
                        class="header-v3-link-content"
                        data-display-name="World"
                      >
                        <li class="sub-section sub-header-section">
                          <a href="https://www.cgtn.com/world"> World </a>
                        </li>
                        <li class="sub-section">
                          <a href="https://www.cgtn.com/world/asia-pacific">
                            Asia-Pacific
                          </a>
                        </li>
                        <li class="sub-section">
                          <a href="https://www.cgtn.com/world/middle-east">
                            Middle East
                          </a>
                        </li>
                        <li class="sub-section">
                          <a href="https://www.cgtn.com/europe"> Europe </a>
                        </li>
                        <li class="sub-section">
                          <a href="https://www.cgtn.com/world/americas">
                            Americas
                          </a>
                        </li>
                        <li class="sub-section">
                          <a href="https://www.cgtn.com/world/africa">
                            Africa
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li
                  data-click-name="Politics"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/politics"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Politics
                  </a>
                </li>
                <li
                  data-click-name="Business"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/business"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Business
                  </a>
                </li>
                <li
                  data-click-name="Opinions"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/opinions"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Opinions
                  </a>
                </li>
                <li
                  data-click-name="Sci-Tech"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/sci-tech"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sci-Tech
                  </a>
                </li>
                <li
                  data-click-name="Culture"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/culture"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Culture
                  </a>
                </li>
                <li
                  data-click-name="Sports"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/sports"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sports
                  </a>
                </li>
                <li
                  data-click-name="Travel"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/travel"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Travel
                  </a>
                </li>
                <li
                  data-click-name="Nature"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/nature"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Nature
                  </a>
                </li>
                <li
                  data-click-name="Picture"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/picture"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Picture
                  </a>
                </li>
                <li
                  data-click-name="Video"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/video"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Video
                  </a>
                </li>
                <li
                  data-click-name="Live"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/live"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Live
                  </a>
                </li>

                <li
                  data-click-name="Documentary"
                  data-page="Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/documentary"
                    class=""
                    target="_self"
                    data-category="Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Documentary
                  </a>
                </li>
              </ul>
            </div>
            <div class="header-v3-main-nav header-v3-main-eu">
              <ul class="header-v3-navlists">
                <li
                  data-click-name="Home"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Home
                  </a>
                </li>
                <li
                  data-click-name="China"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/china"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    China
                  </a>
                </li>
                <li
                  data-click-name="World"
                  data-page="2023 Home"
                  data-list="eu_children_list"
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/world"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    World
                    <i class="icon-top cg-com-sprite"></i>
                  </a>
                  <div class="header-nav-anotherlist" style="display: none">
                    <div class="header-v3-mainbody">
                      <ul
                        class="header-v3-link-content"
                        data-display-name="World"
                      >
                        <li class="sub-section sub-header-section">
                          <a href="https://www.cgtn.com/world"> World </a>
                        </li>
                        <li class="sub-section">
                          <a href="https://www.cgtn.com/world/asia-pacific">
                            Asia-Pacific
                          </a>
                        </li>
                        <li class="sub-section">
                          <a href="https://www.cgtn.com/world/middle-east">
                            Middle East
                          </a>
                        </li>
                        <li class="sub-section">
                          <a href="https://www.cgtn.com/world/americas">
                            Americas
                          </a>
                        </li>
                        <li class="sub-section">
                          <a href="https://www.cgtn.com/world/africa">
                            Africa
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li
                  data-click-name="Europe"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/europe"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Europe
                  </a>
                </li>
                <li
                  data-click-name="Politics"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/politics"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Politics
                  </a>
                </li>
                <li
                  data-click-name="Business"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/business"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Business
                  </a>
                </li>
                <li
                  data-click-name="Opinions"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/opinions"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Opinions
                  </a>
                </li>
                <li
                  data-click-name="Sci-Tech"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/sci-tech"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sci-Tech
                  </a>
                </li>
                <li
                  data-click-name="Culture"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/culture"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Culture
                  </a>
                </li>
                <li
                  data-click-name="Sports"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/sports"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sports
                  </a>
                </li>
                <li
                  data-click-name="Travel"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/travel"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Travel
                  </a>
                </li>
                <li
                  data-click-name="Nature"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/nature"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Nature
                  </a>
                </li>
                <li
                  data-click-name="Picture"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/picture"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Picture
                  </a>
                </li>
                <li
                  data-click-name="Video"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/video"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Video
                  </a>
                </li>
                <li
                  data-click-name="Live"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/live"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Live
                  </a>
                </li>
                <li
                  data-click-name="Documentary"
                  data-page="2023 Home"
                  data-list=""
                  class="nav-v3-li"
                >
                  <a
                    href="https://www.cgtn.com/documentary"
                    class="nav-v3-link"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Documentary
                  </a>
                </li>
              </ul>
            </div>
            <div class="header-v3-menu J-header-v3-menu"></div>
            <a
              href="https://www.cgtn.com/search?keyword="
              class="header-v3-search"
              target="_self"
              data-category="2023 Home"
              data-list=""
              data-action="Search_Click"
              data-label=""
              data-position=""
              data-index=""
              data-news-id=""
              data-time=""
            >
            </a>
            <div class="header-v3-medialist">
              <a
                class="media-list-v3 header-media-radio currentactive"
                article="{}"
                href="https://radio.cgtn.com"
                action="Nav_Click"
                target="_self"
                data-category="Home"
                data-list=""
                data-action="Nav_Click"
                data-label=""
                data-position=""
                data-index=""
                data-news-id=""
                data-time=""
                ><i class="icon-default"></i>Radio</a
              >
              <a
                class="media-list-v3 header-media-tv"
                article="{}"
                href="https://www.cgtn.com/tv"
                action="Nav_Click"
                target="_self"
                data-category="Home"
                data-list=""
                data-action="Nav_Click"
                data-label=""
                data-position=""
                data-index=""
                data-news-id=""
                data-time=""
                ><i class="icon-default"></i>TV</a
              >
            </div>
          </div>
        </div>
        <div class="header-v3-ipad-menulist J-header-v3-ipad-menulist">
          <div class="header-v3-menu-warp">
            <div class="header-v3-m-nav-bj">
              <ul class="header-v3-menu-content header-v3-menulist-language">
                <li>
                  <a
                    href="javascript:;"
                    class="header-v3-secnav-icon header-v3-secnav-icon-lang J-language-more"
                    >EXPLORE MORE<i class="m-header-section-more"></i
                  ></a>
                  <div class="header-v3-menulist-lang-con J-language-content">
                    <a
                      href="https://www.cgtn.com/tv"
                      class="m-nav-section-v3-children"
                      target="_blank"
                      data-category="2023 Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      English
                    </a>
                    <a
                      href="https://espanol.cgtn.com"
                      class="m-nav-section-v3-children"
                      target="_blank"
                      data-category="2023 Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      Español
                    </a>
                    <a
                      href="https://francais.cgtn.com"
                      class="m-nav-section-v3-children"
                      target="_blank"
                      data-category="2023 Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      Français
                    </a>
                    <a
                      href="https://arabic.cgtn.com"
                      class="m-nav-section-v3-children"
                      target="_blank"
                      data-category="2023 Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      العربية
                    </a>
                    <a
                      href="https://russian.cgtn.com"
                      class="m-nav-section-v3-children"
                      target="_blank"
                      data-category="2023 Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      Русский
                    </a>
                    <a
                      href="https://www.cgtn.com/channel/documentary"
                      class="m-nav-section-v3-children"
                      target="_blank"
                      data-category="2023 Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      Documentary
                    </a>
                    <a
                      href="https://www.cctvplus.com"
                      class="m-nav-section-v3-children"
                      target="_blank"
                      data-category="2023 Home"
                      data-list=""
                      data-action="ExploreMore_Click"
                      data-label=""
                      data-position=""
                      data-index=""
                      data-news-id=""
                      data-time=""
                    >
                      CCTV+
                    </a>
                  </div>
                </li>
              </ul>
              <ul class="header-v3-menu-content">
                <li
                  data-click-name="Home"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                    >Home</a
                  >
                </li>
                <li
                  data-click-name="China"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/china"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    China
                  </a>
                </li>
                <li
                  data-click-name="World"
                  data-list="children_list"
                  class="m-nav-section-v3"
                >
                  <a
                    href="javascript:;"
                    class="m-nav-section-v3-first header-m-nav-more J-m-nav-more"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    World
                    <i class="m-header-section-more"></i>
                  </a>
                  <div class="header-v3-m-children">
                    <div
                      data-click-name="World"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        World
                      </a>
                    </div>
                    <div
                      data-click-name="Asia-Pacific"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/asia-pacific"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Asia-Pacific
                      </a>
                    </div>
                    <div
                      data-click-name="Middle East"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/middle-east"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Middle East
                      </a>
                    </div>
                    <div
                      data-click-name="Europe"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/europe"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Europe
                      </a>
                    </div>
                    <div
                      data-click-name="Americas"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/americas"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Americas
                      </a>
                    </div>

                    <div
                      data-click-name="Africa"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/africa"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Africa
                      </a>
                    </div>
                  </div>
                </li>
                <li
                  data-click-name="Politics"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/politics"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Politics
                  </a>
                </li>
                <li
                  data-click-name="Business"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/business"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Business
                  </a>
                </li>
                <li
                  data-click-name="Opinions"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/opinions"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Opinions
                  </a>
                </li>
                <li
                  data-click-name="Sci-Tech"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/sci-tech"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sci-Tech
                  </a>
                </li>
                <li
                  data-click-name="Culture"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/culture"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Culture
                  </a>
                </li>
                <li
                  data-click-name="Sports"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/sports"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sports
                  </a>
                </li>
                <li
                  data-click-name="Travel"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/travel"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Travel
                  </a>
                </li>
                <li
                  data-click-name="Nature"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/nature"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Nature
                  </a>
                </li>
                <li
                  data-click-name="Picture"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/picture"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Picture
                  </a>
                </li>
                <li
                  data-click-name="Video"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/video"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Video
                  </a>
                </li>
                <li
                  data-click-name="Live"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/live"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Live
                  </a>
                </li>
                <li
                  data-click-name="Documentary"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/documentary"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Documentary
                  </a>
                </li>
              </ul>
            </div>
            <div class="header-v3-m-nav-eu">
              <ul class="header-v3-menu-content">
                <li
                  data-click-name="Home"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Home
                  </a>
                </li>
                <li
                  data-click-name="China"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/china"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    China
                  </a>
                </li>
                <li
                  data-click-name="World"
                  data-list="eu_children_list"
                  class="m-nav-section-v3"
                >
                  <a
                    href="javascript:;"
                    class="m-nav-section-v3-first header-m-nav-more J-m-nav-more"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    World
                    <i class="m-header-section-more"></i>
                  </a>
                  <div class="header-v3-m-children">
                    <div
                      data-click-name="World"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        World
                      </a>
                    </div>
                    <div
                      data-click-name="Asia-Pacific"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/asia-pacific"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Asia-Pacific
                      </a>
                    </div>
                    <div
                      data-click-name="Middle East"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/middle-east"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Middle East
                      </a>
                    </div>
                    <div
                      data-click-name="Americas"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/americas"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Americas
                      </a>
                    </div>

                    <div
                      data-click-name="Africa"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/africa"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Africa
                      </a>
                    </div>
                  </div>
                </li>
                <li
                  data-click-name="Europe"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/europe"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Europe
                  </a>
                </li>
                <li
                  data-click-name="Politics"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/politics"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Politics
                  </a>
                </li>
                <li
                  data-click-name="Business"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/business"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Business
                  </a>
                </li>
                <li
                  data-click-name="Opinions"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/opinions"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Opinions
                  </a>
                </li>
                <li
                  data-click-name="Sci-Tech"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/sci-tech"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sci-Tech
                  </a>
                </li>
                <li
                  data-click-name="Culture"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/culture"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Culture
                  </a>
                </li>
                <li
                  data-click-name="Sports"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/sports"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sports
                  </a>
                </li>
                <li
                  data-click-name="Travel"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/travel"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Travel
                  </a>
                </li>
                <li
                  data-click-name="Nature"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/nature"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Nature
                  </a>
                </li>
                <li
                  data-click-name="Picture"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/picture"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Picture
                  </a>
                </li>
                <li
                  data-click-name="Video"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/video"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Video
                  </a>
                </li>
                <li
                  data-click-name="Live"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/live"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Live
                  </a>
                </li>
                <li
                  data-click-name="Documentary"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/documentary"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Documentary
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 移动端 -->
      <div class="m-header-v3">
        <div class="m-header-v3-top J-header-v3-bar-m">
          <div class="header-v3-content-weather"></div>
          <a
            href="https://www.cgtn.com"
            class="m-header-v3-logo"
            target="_self"
            data-category="2023 Home"
            data-list=""
            data-action="Logo_Click"
            data-label=""
            data-position=""
            data-index=""
            data-news-id=""
            data-time=""
          ></a>
          <div class="m-header-v3-logincon-warp">
            <a href="#language_" class="m-header-v3-logincon-language J-top-language-btn-m"
              >Language</a
            >
            <div class="m-header-v3-logincon">
              <div class="m-title-item m-title-item-message J_msg">
                <i class="icon-default"></i>
              </div>
              <div class="m-title-item m-title-item-sign J_login_m">
                <span class="m_signin_value">SIGN IN</span>
                <span class="m_signin_value_active">USER</span>
                <i class="icon-default"></i>
                <div class="m-title-login-content J_login_content">
                  <a class="J_accout">Your account</a>
                  <a class="J_signout">Sign out</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="m-header-v3-navwarp J-header-v3-nav-warp-m">
          <div class="m-header-v3-menu J-header-v3-menu-m"></div>
          <div class="m-header-v3-navls">
            <a
              href="https://radio.cgtn.com"
              class="m-media-list-v3 m-header-media-radio currentactive"
              target="_self"
              data-category="2023 Home"
              data-list=""
              data-action="Nav_Click"
              data-label=""
              data-position=""
              data-index=""
              data-news-id=""
              data-time=""
            >
              <i class="icon-default"></i>Radio</a
            >
            <a
              href="https://www.cgtn.com/tv"
              class="m-media-list-v3 m-header-media-tv"
              target="_self"
              data-category="2023 Home"
              data-list=""
              data-action="Nav_Click"
              data-label=""
              data-position=""
              data-index=""
              data-news-id=""
              data-time=""
            >
              <i class="icon-default"></i>TV</a
            >
          </div>
          <a
            href="https://www.cgtn.com/search?keyword="
            class="m-header-v3-search"
            target="_self"
            data-category="2023 Home"
            data-list=""
            data-action="Search_Click"
            data-label=""
            data-position=""
            data-index=""
            data-news-id=""
            data-time=""
          >
          </a>
        </div>
        <div class="m-header-menu-list J-header-menu-list-m">
          <div class="header-v3-menu-warp">
            <ul class="header-v3-menu-content header-v3-menulist-rss">
              <li>
                <a
                  href="https://www.cgtn.com/subscribe/newsletter.html"
                  class="header-v3-secnav-icon header-v3-secnav-icon-sub"
                  >Newsletters<i class="icon-default"></i
                ></a>
              </li>
              <li>
                <a
                  href="https://www.cgtn.com/subscribe/rss.html"
                  class="header-v3-secnav-icon header-v3-secnav-icon-rss"
                  >RSS<i class="icon-default"></i
                ></a>
              </li>
            </ul>
            <ul class="header-v3-menu-content header-v3-menulist-language">
              <li>
                <a
                  href="javascript:;"
                  class="header-v3-secnav-icon header-v3-secnav-icon-lang J-language-more"
                  >EXPLORE MORE<i class="m-header-section-more"></i
                ></a>
                <div class="header-v3-menulist-lang-con J-language-content">
                  <a
                    href="https://www.cgtn.com/tv"
                    class="m-nav-section-v3-children"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    English
                  </a>
                  <a
                    href="https://espanol.cgtn.com"
                    class="m-nav-section-v3-children"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Español
                  </a>
                  <a
                    href="https://francais.cgtn.com"
                    class="m-nav-section-v3-children"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Français
                  </a>
                  <a
                    href="https://arabic.cgtn.com"
                    class="m-nav-section-v3-children"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    العربية
                  </a>
                  <a
                    href="https://russian.cgtn.com"
                    class="m-nav-section-v3-children"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Русский
                  </a>
                  <a
                    href="https://www.cgtn.com/channel/documentary"
                    class="m-nav-section-v3-children"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Documentary
                  </a>
                  <a
                    href="https://www.cctvplus.com"
                    class="m-nav-section-v3-children"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="ExploreMore_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    CCTV+
                  </a>
                </div>
              </li>
            </ul>
            <div class="header-v3-m-nav-bj">
              <ul class="header-v3-menu-content">
                <li
                  data-click-name="Home"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Home
                  </a>
                </li>

                <li
                  data-click-name="China"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/china"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    China
                  </a>
                </li>

                <li
                  data-click-name="World"
                  data-list="children_list"
                  class="m-nav-section-v3"
                >
                  <a
                    href="javascript:;"
                    class="m-nav-section-v3-first header-m-nav-more J-m-nav-more"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    World
                    <i class="m-header-section-more"></i>
                  </a>
                  <div class="header-v3-m-children">
                    <div
                      data-click-name="World"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        World
                      </a>
                    </div>
                    <div
                      data-click-name="Asia-Pacific"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/asia-pacific"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Asia-Pacific
                      </a>
                    </div>
                    <div
                      data-click-name="Middle East"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/middle-east"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Middle East
                      </a>
                    </div>
                    <div
                      data-click-name="Europe"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/europe"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Europe
                      </a>
                    </div>
                    <div
                      data-click-name="Americas"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/americas"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Americas
                      </a>
                    </div>
                    <div
                      data-click-name="Africa"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/africa"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Africa
                      </a>
                    </div>
                  </div>
                </li>

                <li
                  data-click-name="Politics"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/politics"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Politics
                  </a>
                </li>

                <li
                  data-click-name="Business"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/business"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Business
                  </a>
                </li>

                <li
                  data-click-name="Opinions"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/opinions"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Opinions
                  </a>
                </li>

                <li
                  data-click-name="Sci-Tech"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/sci-tech"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sci-Tech
                  </a>
                </li>

                <li
                  data-click-name="Culture"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/culture"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Culture
                  </a>
                </li>

                <li
                  data-click-name="Sports"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/sports"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sports
                  </a>
                </li>

                <li
                  data-click-name="Travel"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/travel"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Travel
                  </a>
                </li>

                <li
                  data-click-name="Nature"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/nature"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Nature
                  </a>
                </li>

                <li
                  data-click-name="Picture"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/picture"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Picture
                  </a>
                </li>

                <li
                  data-click-name="Video"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/video"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Video
                  </a>
                </li>

                <li
                  data-click-name="Live"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/live"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Live
                  </a>
                </li>

                <li
                  data-click-name="Documentary"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/documentary"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Documentary
                  </a>
                </li>
              </ul>
            </div>
            <div class="header-v3-m-nav-eu">
              <ul class="header-v3-menu-content">
                <li
                  data-click-name="Home"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Home
                  </a>
                </li>
                <li
                  data-click-name="China"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/china"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    China
                  </a>
                </li>
                <li
                  data-click-name="World"
                  data-list="eu_children_list"
                  class="m-nav-section-v3"
                >
                  <a
                    href="javascript:;"
                    class="m-nav-section-v3-first header-m-nav-more J-m-nav-more"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    World
                    <i class="m-header-section-more"></i>
                  </a>
                  <div class="header-v3-m-children">
                    <div
                      data-click-name="World"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        World
                      </a>
                    </div>
                    <div
                      data-click-name="Asia-Pacific"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/asia-pacific"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Asia-Pacific
                      </a>
                    </div>
                    <div
                      data-click-name="Middle East"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/middle-east"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Middle East
                      </a>
                    </div>
                    <div
                      data-click-name="Americas"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/americas"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Americas
                      </a>
                    </div>

                    <div
                      data-click-name="Africa"
                      class="m-nav-section-v3 m-nav-section-v3-children"
                    >
                      <a
                        href="https://www.cgtn.com/world/africa"
                        class=""
                        target="_self"
                        data-category="2023 Home"
                        data-list=""
                        data-action="Nav_Click"
                        data-label=""
                        data-position=""
                        data-index=""
                        data-news-id=""
                        data-time=""
                      >
                        Africa
                      </a>
                    </div>
                  </div>
                </li>
                <li
                  data-click-name="Europe"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/europe"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Europe
                  </a>
                </li>
                <li
                  data-click-name="Politics"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/politics"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Politics
                  </a>
                </li>
                <li
                  data-click-name="Business"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/business"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Business
                  </a>
                </li>
                <li
                  data-click-name="Opinions"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/opinions"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Opinions
                  </a>
                </li>
                <li
                  data-click-name="Sci-Tech"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/sci-tech"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sci-Tech
                  </a>
                </li>
                <li
                  data-click-name="Culture"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/culture"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Culture
                  </a>
                </li>
                <li
                  data-click-name="Sports"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/sports"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Sports
                  </a>
                </li>
                <li
                  data-click-name="Travel"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/travel"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Travel
                  </a>
                </li>
                <li
                  data-click-name="Nature"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/nature"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Nature
                  </a>
                </li>
                <li
                  data-click-name="Picture"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/picture"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Picture
                  </a>
                </li>
                <li
                  data-click-name="Video"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/video"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Video
                  </a>
                </li>
                <li
                  data-click-name="Live"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/live"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Live
                  </a>
                </li>
                <li
                  data-click-name="Documentary"
                  data-list=""
                  class="m-nav-section-v3"
                >
                  <a
                    href="https://www.cgtn.com/documentary"
                    class="m-nav-section-v3-first"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Nav_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                    Documentary
                  </a>
                </li>
              </ul>
            </div>
            <div class="header-v3-menulist-share">
              <ul class="header-v3-follow-common">
                <li class="fl">
                  <a
                    href="https://www.facebook.com/ChinaGlobalTVNetwork"
                    class="icon fb cg-com-sprite"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Socialmedia_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <li class="fl">
                  <a
                    href="https://twitter.com/CGTNOfficial"
                    class="icon twitter cg-com-sprite"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Socialmedia_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <li class="fl">
                  <a
                    href="https://www.youtube.com/CGTN"
                    class="icon youtube cg-com-sprite"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Socialmedia_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <li class="fl">
                  <a
                    href="https://www.instagram.com/cgtn"
                    class="icon ins cg-com-sprite"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Socialmedia_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <li class="fl">
                  <a
                    href="https://v.douyin.com/2VMKvpC"
                    class="icon douyin cg-com-sprite"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Socialmedia_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <li class="fl">
                  <a
                    href="http://weibo.com/cctvnewsbeijing"
                    class="icon weibo cg-com-sprite"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Socialmedia_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <li class="fl">
                  <a
                    href="javascript:;"
                    class="icon wechat cg-com-sprite"
                    target="_self"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Socialmedia_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <li class="fl">
                  <a
                    href="https://www.pinterest.com/CGTNOfficial"
                    class="icon pinterest cg-com-sprite"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Socialmedia_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <!-- <li class="fl">
                            <a href="http://www.miaopai.com/u/paike_1300pl6n77" class="icon miaopai cg-com-sprite" target="_blank" data-category="2023 Home" data-list="" data-action="Socialmedia_Click" data-label="" data-position="" data-index="" data-news-id="" data-time="">
                            </a>
                                </li> -->
                <li class="fl">
                  <a
                    href="https://www.toutiao.com/c/user/82615367134/#mid=1588042509127693"
                    class="icon toutiao cg-com-sprite"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Socialmedia_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <li class="fl">
                  <a
                    href="https://www.quora.com/profile/CGTN-Social-Team"
                    class="icon quora cg-com-sprite"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Socialmedia_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
                <li class="fl">
                  <a
                    href="https://www.linkedin.com/company/cgtn"
                    class="icon linkedin cg-com-sprite"
                    target="_blank"
                    data-category="2023 Home"
                    data-list=""
                    data-action="Socialmedia_Click"
                    data-label=""
                    data-position=""
                    data-index=""
                    data-news-id=""
                    data-time=""
                  >
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="header-v3-m-wehat J-header-v3-m-wehat">
          <div class="wx-wrap-v3"></div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      msg: "header",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@media (max-width: 767px){
    .m-header-v3-navls{
        a{
            color: #fff;
            &.currentactive{
                color: #d2be68;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Header_v3.vue